// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock_search_add_container {
  display: flex;
  justify-content: space-between;
  padding: 25px;
  flex-wrap: wrap;
}
.stock_search_bar {
  width: 400px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid gray;
  outline: none;
  padding-left: 10px;
}
.stock_search_bar:focus {
  border: 1px solid lightblue;
}
.Add_stock_btn {
  color: white;
  width: 150px;
  border-radius: 50px;
  border: none;
  background-color: #d65b3c;
  font-weight: 700;
}
.show_building_name_material_wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  padding: 20px;
}

.show_building_name_material {
  background-color: #ffffff;
  border-radius: 11px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 350px;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  height: 269px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: anchor-center;
  gap: 5px;
}

.show_building_name_material:hover {
  transform: translateY(-5px);
}

.material_status {
  color: #0697b1;
  font-size: 14px;
  margin: 10px 0;
}

.material_card_view_container {
  margin-top: 15px;
  width: 100%;
}

.material_card_view_container button {
    background-color: rgb(224 95 44);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.2s ease-in-out;
    width: 100%;
}
.material_card_view_container button:hover {
  background-color: rgb(153, 54, 5);
}

.Add_stock-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.Add_stock_form {
  background-color: #fff;
  padding: 45px 20px;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.Add_stock_input {
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s ease;
}

.Add_stock_input:focus {
  border-color: #007bff;
}

.Add_stock_submit_button {
  background-color: #007bff;
  color: white;
  padding: 15px 14px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.Add_stock_submit_button:hover {
  background-color: #0056b3;
}

.Add_stock_form_close_button {
  position: absolute;
  top: 5px;
  right: 14px;
  background: #ff4d4d;
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add_stock_table_wrapper {
  max-height: 437px;
  overflow-y: auto;
  /* border: 1px solid #ddd; */
  border-radius: 8px;
  /* padding: 25px; */
}

.add_stock_table {
  width: 100%;
  border-collapse: collapse;
  /* table-layout: fixed; */
  padding: 25px;
}

.add_stock_table th,
.add_stock_table td {
  padding: 12px 16px;
  border: 1px solid #ddd;
  text-align: left;
  word-wrap: break-word;
}
.add_stock_table thead th {
  position: sticky;
  top: 0;
  background-color: #d65b3c;
  color: white;
  z-index: 2;
  font-weight: 700;
  padding: 8px 20px;
}

.add_stock_table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.add_stock_table tbody tr:hover {
  background-color: #eef3f8;
}

@media (max-width: 768px) {
  .add_stock_table th,
  .add_stock_table td {
    font-size: 14px;
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .add_stock_table th,
  .add_stock_table td {
    font-size: 12px;
    padding: 8px;
  }
  .stock_search_add_container {
    justify-content: center;
    padding: 15px;

    gap: 25px;
  }
  .Add_stock_btn {
    height: 35px;
  }
}

.Stock_in_btn {
  height: 40px;
  width: 150px;
  background-color: #d65b3c;
  color: whitesmoke;
  border: none;
  border-radius: 5px;
  font-weight: 600;
}

.Stock_out_btn {
  margin-top: 5px;
  height: 35px;
  width: 150px;
  background-color: #d65b3c;
  color: whitesmoke;
  border: none;
  border-radius: 5px;
  font-weight: 600;
}

/* Overlay wrapper */
.existing_stock_add_form_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  box-sizing: border-box;
}

/* Modal form container */
.existing_stock_add_form {
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
}

/* Close button */
.existing_stock_add_form_close_button {
  position: absolute;
  top: 10px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #ff0000;
}

/* Inputs */
.existing_stock_add_form_input {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  width: 100%;
  box-sizing: border-box;
}

/* Submit Button */
.existing_stock_add_form_submit_btn {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  background-color: #e02c2c;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

/* Overlay background */
.usedstock_form_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Dark overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 1rem;
  box-sizing: border-box;
}

/* Form container */
.usedQuantiyStock_form {
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
}

/* Close button */
.usedstock_form_close_button {
  position: absolute;
  top: 10px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #333;
}

/* Input field */
.usedstock_form_input {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  width: 100%;
}

/* Submit button */
.usedstock_form_submit_button {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  background-color: #2c3951;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.usedstock_form_submit_button:hover {
  background-color: #1e2635;
}

.stock_details_button_container {
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-left: 15px;
  margin-top: 20px;
}

.usedStocktable-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
}

.usedStockDetailTable {
  width: 100%;
  border-collapse: collapse;
  min-width: 400px;
  font-size: 14px;
  margin-top: 50px;
}

.usedStockDetailTable th,
.usedStockDetailTable td {
  border: 1px solid #ccc;
  padding: 8px 12px;
  text-align: left;
}

.usedStockDetailTable th {
  background-color: #d65b3c;
  font-weight: bold;
  color: whitesmoke;
}

@media (max-width: 600px) {
  .usedStockDetailTable {
    font-size: 12px;
  }

  .usedStockDetailTable th,
  .usedStockDetailTable td {
    padding: 6px 8px;
  }
}

.editStock_popup_form_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.editStock_popup_form {
  background: white;
  padding: 20px 25px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
}

.editStock_popup_form_close_button {
  position: absolute;
  top: 10px;
  right: 15px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.editStock_popup_form_input {
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.editStock_popup_form_label {
  font-weight: bold;
  font-size: 14px;
}

.editStock_popup_form_submit_button {
  background-color: #2c3951;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
}

@media (max-width: 480px) {
  .editStock_popup_form {
    padding: 16px;
    font-size: 14px;
  }

  .editStock_popup_form_input,
  .editStock_popup_form_submit_button {
    font-size: 13px;
    padding: 8px;
  }

  .editStock_popup_form_close_button {
    font-size: 14px;
    width: 28px;
    height: 28px;
  }
}
.Stock_view_btn {
  margin-top: 5px;
  height: 35px;
  width: 150px;
  background-color: #3c8dbc;
  color: whitesmoke;
  border: none;
  border-radius: 5px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/material/Material.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,6CAA6C;IAC7C,WAAW;AACf;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,aAAa;;IAEb,SAAS;EACX;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,iBAAiB;EACvD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".stock_search_add_container {\n  display: flex;\n  justify-content: space-between;\n  padding: 25px;\n  flex-wrap: wrap;\n}\n.stock_search_bar {\n  width: 400px;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid gray;\n  outline: none;\n  padding-left: 10px;\n}\n.stock_search_bar:focus {\n  border: 1px solid lightblue;\n}\n.Add_stock_btn {\n  color: white;\n  width: 150px;\n  border-radius: 50px;\n  border: none;\n  background-color: #d65b3c;\n  font-weight: 700;\n}\n.show_building_name_material_wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: center;\n  padding: 20px;\n}\n\n.show_building_name_material {\n  background-color: #ffffff;\n  border-radius: 11px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 350px;\n  padding: 20px;\n  text-align: center;\n  transition: transform 0.2s ease-in-out;\n  cursor: pointer;\n  height: 269px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: anchor-center;\n  gap: 5px;\n}\n\n.show_building_name_material:hover {\n  transform: translateY(-5px);\n}\n\n.material_status {\n  color: #0697b1;\n  font-size: 14px;\n  margin: 10px 0;\n}\n\n.material_card_view_container {\n  margin-top: 15px;\n  width: 100%;\n}\n\n.material_card_view_container button {\n    background-color: rgb(224 95 44);\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: background-color 0.2s ease-in-out;\n    width: 100%;\n}\n.material_card_view_container button:hover {\n  background-color: rgb(153, 54, 5);\n}\n\n.Add_stock-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.Add_stock_form {\n  background-color: #fff;\n  padding: 45px 20px;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.Add_stock_input {\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  outline: none;\n  transition: border-color 0.3s ease;\n}\n\n.Add_stock_input:focus {\n  border-color: #007bff;\n}\n\n.Add_stock_submit_button {\n  background-color: #007bff;\n  color: white;\n  padding: 15px 14px;\n  font-size: 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.Add_stock_submit_button:hover {\n  background-color: #0056b3;\n}\n\n.Add_stock_form_close_button {\n  position: absolute;\n  top: 5px;\n  right: 14px;\n  background: #ff4d4d;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.add_stock_table_wrapper {\n  max-height: 437px;\n  overflow-y: auto;\n  /* border: 1px solid #ddd; */\n  border-radius: 8px;\n  /* padding: 25px; */\n}\n\n.add_stock_table {\n  width: 100%;\n  border-collapse: collapse;\n  /* table-layout: fixed; */\n  padding: 25px;\n}\n\n.add_stock_table th,\n.add_stock_table td {\n  padding: 12px 16px;\n  border: 1px solid #ddd;\n  text-align: left;\n  word-wrap: break-word;\n}\n.add_stock_table thead th {\n  position: sticky;\n  top: 0;\n  background-color: #d65b3c;\n  color: white;\n  z-index: 2;\n  font-weight: 700;\n  padding: 8px 20px;\n}\n\n.add_stock_table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.add_stock_table tbody tr:hover {\n  background-color: #eef3f8;\n}\n\n@media (max-width: 768px) {\n  .add_stock_table th,\n  .add_stock_table td {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .add_stock_table th,\n  .add_stock_table td {\n    font-size: 12px;\n    padding: 8px;\n  }\n  .stock_search_add_container {\n    justify-content: center;\n    padding: 15px;\n\n    gap: 25px;\n  }\n  .Add_stock_btn {\n    height: 35px;\n  }\n}\n\n.Stock_in_btn {\n  height: 40px;\n  width: 150px;\n  background-color: #d65b3c;\n  color: whitesmoke;\n  border: none;\n  border-radius: 5px;\n  font-weight: 600;\n}\n\n.Stock_out_btn {\n  margin-top: 5px;\n  height: 35px;\n  width: 150px;\n  background-color: #d65b3c;\n  color: whitesmoke;\n  border: none;\n  border-radius: 5px;\n  font-weight: 600;\n}\n\n/* Overlay wrapper */\n.existing_stock_add_form_wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6); /* semi-transparent background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n/* Modal form container */\n.existing_stock_add_form {\n  background-color: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n}\n\n/* Close button */\n.existing_stock_add_form_close_button {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  color: #ff0000;\n}\n\n/* Inputs */\n.existing_stock_add_form_input {\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Submit Button */\n.existing_stock_add_form_submit_btn {\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  background-color: #e02c2c;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n/* Overlay background */\n.usedstock_form_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6); /* Dark overlay */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n/* Form container */\n.usedQuantiyStock_form {\n  background-color: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n}\n\n/* Close button */\n.usedstock_form_close_button {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  color: #333;\n}\n\n/* Input field */\n.usedstock_form_input {\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  width: 100%;\n}\n\n/* Submit button */\n.usedstock_form_submit_button {\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  background-color: #2c3951;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.usedstock_form_submit_button:hover {\n  background-color: #1e2635;\n}\n\n.stock_details_button_container {\n  display: flex;\n  justify-content: center;\n  gap: 25px;\n  margin-left: 15px;\n  margin-top: 20px;\n}\n\n.usedStocktable-responsive-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.usedStockDetailTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 400px;\n  font-size: 14px;\n  margin-top: 50px;\n}\n\n.usedStockDetailTable th,\n.usedStockDetailTable td {\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.usedStockDetailTable th {\n  background-color: #d65b3c;\n  font-weight: bold;\n  color: whitesmoke;\n}\n\n@media (max-width: 600px) {\n  .usedStockDetailTable {\n    font-size: 12px;\n  }\n\n  .usedStockDetailTable th,\n  .usedStockDetailTable td {\n    padding: 6px 8px;\n  }\n}\n\n.editStock_popup_form_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.editStock_popup_form {\n  background: white;\n  padding: 20px 25px;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  position: relative;\n}\n\n.editStock_popup_form_close_button {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n}\n\n.editStock_popup_form_input {\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n}\n\n.editStock_popup_form_label {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.editStock_popup_form_submit_button {\n  background-color: #2c3951;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n@media (max-width: 480px) {\n  .editStock_popup_form {\n    padding: 16px;\n    font-size: 14px;\n  }\n\n  .editStock_popup_form_input,\n  .editStock_popup_form_submit_button {\n    font-size: 13px;\n    padding: 8px;\n  }\n\n  .editStock_popup_form_close_button {\n    font-size: 14px;\n    width: 28px;\n    height: 28px;\n  }\n}\n.Stock_view_btn {\n  margin-top: 5px;\n  height: 35px;\n  width: 150px;\n  background-color: #3c8dbc;\n  color: whitesmoke;\n  border: none;\n  border-radius: 5px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
